<template>
  <b-dropdown @hidden="dropdownClose = true" @show="dropdownClose = false" size="md" variant="link" toggle-class="text-decoration-none">
    <template #button-content>
      <div class="pagintaiondDropdown d-flex justify-content-center align-items-center">
        <i aria-hidden="true" class="fa-regular fa-align-left me-2"></i>
        {{ title }}
        <i v-if="dropdownClose" aria-hidden="true" class="fa fa-chevron-down ms-2"></i>
        <i v-else aria-hidden="true" class="fa fa-chevron-up ms-2"></i>
      </div>
    </template>
    <b-dropdown-item v-for="item in items" :key="item.id" @click="changeValue(item.id)">{{ item.text }}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'دسته بندی',
    },
  },
  data() {
    return {
      dropdownClose: true,
      items: [
        {
          text: 'دسته بندی',
          id: 0,
        },
        {
          text: 'زیر دسته',
          id: 1,
        },
      ],
    }
  },
  methods: {
    changeValue(id) {
      this.currentValue = this.items.find((el) => el.id === id)
      this.$emit('dropdownSelected', this.currentValue)
    },
  },
  mounted() {
    this.dropdownClose = true
  },
}
</script>

<style scoped lang="scss">
::v-deep button {
  cursor: pointer;
  position: relative;
  border-radius: 5px;
  padding: 8.5px 5px;
  outline: none;
  background-color: #34c38f;
  color: #fff;
  width: 148px;
  height: 36px;
}

i {
  margin-right: 5px;
  font-size: 14px;
}

span {
  width: 100%;
}
.fa-chevron-up,.fa-chevron-down{
  font-size: 10px;
}
</style>